import React, { Component } from 'react'
import { observer } from 'mobx-react'
import SelectField from 'material-ui/SelectField';
import Doc2HdeptStore from '../stores/Doc2HdeptStore';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash'
import FontAwesome from 'react-fontawesome'

export default observer(class Doc2HdeptObject extends Component {
  handleHdeptChange = (e, idx, val) => {
    Doc2HdeptStore.setHdept(val)
    // location.href = stringified;
  }

  handleDoctorChange = (e, idx, val) => {
    // Doc2HdeptStore.doctor = val;
    Doc2HdeptStore.setDoctor(val);
  }

  componentDidMount(){
    Doc2HdeptStore.currentSelect = null
    Doc2HdeptStore.hdept = null
    Doc2HdeptStore.doctor = ''
    Doc2HdeptStore.hdept_quantity = null
    Doc2HdeptStore.events = []
  }

  render() {
    return (
      <div style={{ display: 'flex', width: '100%' }}>

        <div style={{ width: '30%', height: '60px' }}>
          <SelectField
            floatingLabelText="醫師"
            floatingLabelFixed={true}
            floatingLabelStyle={{ marginLeft: '4px', color: 'black' }}
            hintText="選擇醫師"
            hintStyle={{ marginLeft: '15px' }}
            inputStyle={{ marginLeft: '15px', fontSize: '17px', color: 'red' }}
            value={Doc2HdeptStore.doctor}
            onChange={this.handleDoctorChange}
            style={{ bottom: '10px', width: '100%', animationIterationCount: '5', animationDelay: '1s' }}
            underlineStyle={{ display: 'none' }}
            id="doctor_part"
            className="animated flash"
            labelStyle={{ width: '100%', paddingRight: '0px' }}
            //floatingLabelStyle={{width:'100%'}}
            menuStyle={{ width: '80%' }}
          >
            {
              _.map(Doc2HdeptStore.doctor_list, (item, key) => {
                return (
                  <MenuItem key={key} value={item.EmpNo} primaryText={item.NameCh} />
                )
              })
            }
          </SelectField>
        </div>

        <FontAwesome
          name='long-arrow-right'
          size='2x'
          style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)', color: 'gray', height:'60px', lineHeight:'60px', margin:'0 10px' }}
        />

        <div style={{ width: '45%', height: '60px' }}>
          <SelectField
            floatingLabelText={((() => {
              if (Doc2HdeptStore.hdept_quantity === null) {
                return `科別`
              } else {
                return `科別(${Doc2HdeptStore.hdept_quantity})`
              }
            })())}
            floatingLabelFixed={true}
            floatingLabelStyle={{ marginLeft: '4px', color: 'black' }}
            hintText="選擇科別"
            hintStyle={{ marginLeft: '15px' }}
            inputStyle={{ marginLeft: '15px', fontSize: '17px' }}
            value={Doc2HdeptStore.hdept}
            onChange={this.handleHdeptChange}
            style={{ bottom: '10px', width: '100%', animationIterationCount: '5', animationDelay: '1s' }}
            underlineStyle={{ display: 'none' }}
            id="hdept_part"
            className="animated flash"
            labelStyle={{ width: '85%',paddingRight:'0px' }}
            disabled={Doc2HdeptStore.currentSelect === null ? true : false}
          >
            {/*<MenuItem key={-1} value="all_doctors" primaryText="<直接選醫師>" />*/}
            {
              _.map(Doc2HdeptStore.hdept_list, (item, key) => {
                return (
                  <MenuItem key={key} value={item.HdeptCode} primaryText={item.HdeptName} />
                )
              })
            }
          </SelectField>
        </div>

        {/*<div style={{ display: 'flex', width: '25%', justifyContent: 'flex-end', marginRight: '10px' }}>
          <RaisedButton
            label="重置條件"
            backgroundColor="#eee"
            labelStyle={{ fontSize: '10px', padding: '0 5px' }}
            style={{ minWidth: '' }}
            onClick={this.reload}
          />
        </div>*/}
      </div>
    )
  }
})


// WEBPACK FOOTER //
// ./src/components/Doc2Hdept.js